// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import "@/assets/iconfont/iconfont.css";
import "@/assets/iconfont/inconfont-fontClass.css";
import config from "../config/config";
import router from "./router";
import axios from "./assets/js/axios";
import "babel-polyfill";
import VueResource from "vue-resource";
import VueBus from "vue-bus";
import store from "./stroe";
import {
  Pagination,
  Dialog,
  Input,
  InputNumber,
  Radio,
  RadioGroup,
  RadioButton,
  Checkbox,
  CheckboxButton,
  CheckboxGroup,
  Select,
  Option,
  OptionGroup,
  Button,
  ButtonGroup,
  DatePicker,
  Alert,
  Icon,
  Row,
  Col,
  Upload,
  Card,
  Steps,
  Step,
  Carousel,
  CarouselItem,
  Cascader,
  Loading,
  MessageBox,
  Message,
  Notification,
  Badge,
  Rate,
  Popover,
  Timeline,
  TimelineItem,
  Tooltip,
  Tabs,
  TabPane
} from "element-ui";

Vue.use(TabPane)
  .use(Tabs)
  .use(Pagination)
  .use(Dialog)
  .use(Input)
  .use(InputNumber)
  .use(Radio)
  .use(RadioGroup)
  .use(RadioButton)
  .use(Checkbox)
  .use(CheckboxButton)
  .use(CheckboxGroup)
  .use(Select)
  .use(Option)
  .use(OptionGroup)
  .use(Button)
  .use(ButtonGroup)
  .use(DatePicker)
  .use(Alert)
  .use(Icon)
  .use(Row)
  .use(Col)
  .use(Upload)
  .use(Card)
  .use(Steps)
  .use(Step)
  .use(Carousel)
  .use(CarouselItem)
  .use(Badge)
  .use(Rate)
  .use(Cascader)
  .use(Popover)
  .use(Timeline)
  .use(TimelineItem)
  .use(Tooltip)
  .use(Tabs)
  .use(TabPane)
  .use(Loading.directive);

Vue.prototype.$config = config;
Vue.prototype.$loading = Loading.service;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.config.productionTip = false;

Vue.use(axios);
Vue.use(VueResource);
Vue.use(VueBus);
import util from "@/assets/js/util";
import filters from "@/filter/index.js";

Vue.use(util).use(filters);
/* eslint-disable no-new */
router.beforeEach((to, from, next) => {
  if (
    to.name !== "products-list" &&
    to.name !== "product-detail" &&
    to.name !== "shopping-cart" &&
    to.name !== "check-order"
  ) {
    if (sessionStorage.getItem("trace_info")) {
      sessionStorage.removeItem("trace_info");
    }
    if (sessionStorage.getItem("rn")) {
      sessionStorage.removeItem("rn");
    }
  }
  next();
});
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
});
window.open_category = {};
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js